<!--
 * @Author: J_Nan
 * @Date: 2021-06-15 15:44:40
 * @LastEditors: J_Nan
 * @LastEditTime: 2021-06-23 11:48:27
-->
<template>
	<div class="course-login" onselectstart="return false;" :class="{ frame: $store.getters.isPc }">
		<!-- 标题 -->
		<template v-if="loginMode === 1">
			<div class="title" style="margin-bottom: 1.226666rem">中国医学科学院健康科普研究中心</div>
		</template>
		<template v-if="loginMode === 2">
			<div class="title">中国医学科学院健康科普研究中心</div>
			<div class="subtitle">若该手机号未注册，我们将自动为您注册</div>
		</template>

		<!-- 密码表单 -->
		<div v-show="loginMode === 1">
			<el-form ref="ruleForm1" :model="formData" :rules="rules">
				<el-form-item prop="phone_number">
					<el-input
						autocomplete="new-password"
						type="number"
						oninput="if(value.length>11)value=value.slice(0,11)"
						maxlength="11"
						v-model="formData.phone_number"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input autocomplete="new-password" :type="passType" v-model="formData.password" placeholder="请输入密码"></el-input>
					<img src="@/assets/close.png" class="eyes-img eyes-close" @click="passType = 'text'" v-show="passType === 'password'" />
					<img src="@/assets/open.png" class="eyes-img eyes-open" @click="passType = 'password'" v-show="passType === 'text'" />
				</el-form-item>

				<div class="row login-btn link" @click="submit">登录</div>
				<div class="row mode-change" @click="loginMode = loginMode === 1 ? 2 : 1">{{ loginMode === 2 ? '密码登录' : '验证码登录' }}</div>
			</el-form>
		</div>
		<!-- 短信登录表单 -->
		<div v-show="loginMode === 2">
			<el-form ref="ruleForm2" :model="formData" :rules="rules">
				<el-form-item prop="phone_number">
					<el-input
						autocomplete="new-password"
						type="number"
						oninput="if(value.length>11)value=value.slice(0,11)"
						maxlength="11"
						v-model="formData.phone_number"
						placeholder="请输入手机号"
					></el-input>
				</el-form-item>
				<el-form-item prop="captcha">
					<el-input autocomplete="new-password" type="number" v-model="formData.captcha" placeholder="请输入验证码"></el-input>
					<div class="get-code link" v-if="captchaTime === 60" @click="smsSend">获取验证码</div>
					<div class="get-code get-code-dis" v-else>{{ captchaTime }}秒后重发</div>
				</el-form-item>
				<div class="row login-btn link" @click="submit">登录</div>
				<div class="row mode-change" v-if="false" @click="loginMode = loginMode === 1 ? 2 : 1">{{ loginMode === 2 ? '密码登录' : '验证码登录' }}</div>
			</el-form>
		</div>
		<!-- 用户协议和隐私协议 -->
		<div class="agreement none-select">
			<el-checkbox v-model="checked"></el-checkbox>
			<div class="text link" @click="checked = !checked">
				登录即视为同意
				<span>《用户协议》</span>
				和
				<span>《隐私协议》</span>
			</div>
		</div>
	</div>
</template>

<script>
let captchaTimeOut = '';
import validate from '@/utils/validate.js';
import { Toast } from 'vant';
export default {
	data() {
		return {
			passType: 'password',
			formData: {
				phone_number: '',
				password: '',
				captcha: ''
			},
			loginMode: 2, // 1=密码登录,2=验证码登录
			rules: {},
			captchaTime: 60,
			captchaBusy: false,
			checked: true
		};
	},
	created() {
		this.mpLogin().then(() => {
			console.log('登录完成');
		});
	},
	methods: {
		submit() {
			if (!this.checked) {
				if (this.$store.getters.isPc) {
					this.$message({
						message: '请阅读并同意《用户协议》和《隐私政策》',
						type: 'warning'
					});
				} else {
					this.$toast('请阅读并同意《用户协议》和《隐私政策》');
				}
				return;
			}
			this.$refs[this.loginMode === 1 ? 'ruleForm1' : 'ruleForm2'].validate(valid => {
				if (valid) {
					this.service2('client/stu/login', {
						...this.formData,
						mode: this.loginMode,
						code: this.$store.getters.code
					})
						.then(res => {
							this.$store.dispatch('setToken', res.data.token);
							this.$store.dispatch('setRefreshToken', res.data.refresh_token);
							this.$store.dispatch('setStuInfo', this.formData.phone_number);
							if (this.$store.getters.isPc) {
								this.$message({
									message: '登录成功',
									type: 'success'
								});
							} else {
								this.$toast('登录成功');
							}
							// 跳转我的课程
							this.$router.replace('/course');
						})
						.catch(res => {});
				}
			});
		},
		// 匹配信息
		metchFormInfo(value) {
			let rules = {};
			if (value === 1) {
				rules = {
					phone_number: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validate.checkPhone, trigger: 'blur' }],
					password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: validate.checkPassword, trigger: 'blur' }]
				};
			} else {
				rules = {
					phone_number: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validate.checkPhone, trigger: 'blur' }],
					captcha: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
				};
			}
			this.rules = rules;
			this.formData = {
				phone_number: '',
				password: '',
				captcha: ''
			};
			this.$nextTick(() => {
				if (this.$refs['ruleForm1']) this.$refs['ruleForm1'].clearValidate();
				if (this.$refs['ruleForm2']) this.$refs['ruleForm2'].clearValidate();
			});
		},
		// 发送短信验证码
		smsSend() {
			if (this.captchaBusy) return;
			Toast.loading({
				message: '发送中...',
				forbidClick: true,
				duration: 0
			});
			this.captchaBusy = true;
			this.service2('client/stu/sendSms', {
				phone_number: this.formData.phone_number
			})
				.then(() => {
					captchaTimeOut = setInterval(() => {
						this.captchaTime--;
						if (this.captchaTime === 0) {
							clearInterval(captchaTimeOut);
							this.captchaTime = 60;
						}
					}, 1000);
				})
				.finally(() => {
					Toast.clear();
					setTimeout(() => {
						this.captchaBusy = false;
					}, 1000);
				});
		}
	},
	watch: {
		loginMode: {
			immediate: true,
			handler: function(value, oldValue) {
				this.metchFormInfo(value);
			}
		}
	}
};
</script>

<style lang="less" scoped>
.course-login {
	padding: 0 0.733rem;
	box-sizing: border-box;
	// 标题
	.title {
		padding: 2.107rem 0 0.3rem 0;
		font-size: 0.5rem;
		font-weight: 500;
		color: #292b3c;
		line-height: 24px;
	}

	.subtitle {
		color: #d5d5d5;
		font-size: 0.32rem;
		margin-bottom: 0.8rem;
	}

	// 表单
	.el-form {
		.eyes-img {
			position: absolute;
			right: 0;
			top: 0;
			bottom: 0;
			margin: auto;
		}

		.eyes-close {
			width: 0.48rem;
			height: 0.24rem;
		}

		.eyes-open {
			width: 0.506666rem;
			height: 0.32rem;
		}

		/deep/ .el-input__inner {
			height: 1.107rem;
			border: none;
			border-radius: 0;
			border-bottom: 1px solid #d5d5d5;

			&::placeholder {
				font-size: 0.427rem;
				font-weight: 400;
				color: #d5d5d5;
				line-height: 1.067rem;
			}
		}

		/deep/ .el-form-item__content {
			display: flex;
			justify-content: space-between;

			.el-button--text {
				span {
					font-size: 0.347rem;
					font-weight: 500;
					color: #d5d5d5;
					line-height: 0.32rem;
				}
			}
		}
		// input输入框设置type=number时，去掉后面的上下按钮
		/* 谷歌 */
		/deep/ input::-webkit-outer-spin-button,
		/deep/ input::-webkit-inner-spin-button {
			-webkit-appearance: none;
			appearance: none;
			margin: 0;
		}

		/* 火狐 */
		/deep/ input {
			-moz-appearance: textfield;
		}

		.get-code {
			width: 2.387rem;
			height: 0.333rem;
			font-size: 0.347rem;
			font-weight: 500;
			color: #13afaf;
		}

		.get-code-dis {
			color: #d5d5d5;
		}

		.login-btn {
			align-items: center;
			justify-content: center;
			width: 8.373rem;
			height: 0.933rem;
			margin: 0.8rem auto 0;
			// background: #017575;
			background: linear-gradient(-90deg, #0ea5a5, #13afaf);
			text-align: center;
			border-radius: 0.467rem;
			font-size: 0.347rem;
			font-weight: 500;
			color: #ffffff;
		}

		.mode-change {
			align-items: center;
			justify-content: center;
			margin: 0 auto;
			margin-top: 0.693333rem;
			font-size: 0.373333rem;
			color: #9b9b9b;
			font-weight: Medium;
		}
	}

	// 用户协议
	.agreement {
		margin-top: 7rem;
		display: flex;
		justify-content: center;
		align-items: center;

		// 复选框未选中样式
		/deep/ .el-checkbox__inner {
			margin-right: 0.147rem;
			width: 0.32rem;
			height: 0.32rem;
			border: 1px solid #cacaca;
			border-radius: 50%;
		}

		// 复选框选中样式
		/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
			background-color: #017575 !important;
			border-color: #017575;

			&::after {
				top: -0.013rem;
				left: 0.08rem;
			}
		}

		.text {
			font-size: 0.32rem;
			font-weight: 400;
			color: #cacaca;
			line-height: 0.32rem;

			span {
				color: #017575;
			}
		}
	}
}
</style>
